import { useState, useRef, useEffect } from "react";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/utils/cn";

interface MemoCellProps {
  value: string | null;
  onChange: (value: string) => void;
  isEditMode: boolean;
  disabled?: boolean;
  onlyView?: boolean;
}

export default function MemoCell({
  value,
  onChange,
  isEditMode,
  disabled = false,
  onlyView = false,
}: MemoCellProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const text = value || "";

  // Auto-resize textarea in edit mode
  useEffect(() => {
    if (isEditMode && textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + "px";
    }
  }, [text, isEditMode]);

  if (isEditMode) {
    return (
      <Textarea
        ref={textareaRef}
        rows={1}
        className="min-h-[30px] w-full resize-none overflow-hidden border-[#D6D6DE] bg-white px-2 py-1 text-sm shadow-none"
        value={text}
        maxLength={50}
        disabled={disabled}
        onChange={(e) => {
          const val = e.target.value;
          if (val.length <= 50) {
            onChange(val);
          }
        }}
      />
    );
  }

  return (
    <div
      className={`text-center comp_textArea cursor-pointer block w-full min-w-0 max-w-[160px]! text-zinc-950!  ${isExpanded ? "whitespace-pre-wrap break-all" : "to-e"
        } ${onlyView && "!text-[#D6D6DE] text-center"
        }`}
      onClick={() => setIsExpanded((prev) => !prev)}
      title={!isExpanded ? text : undefined}
    >
      {text || <span className={cn("opacity-40 text-center", onlyView && "!text-[#D6D6DE] ")}>-</span>}
    </div>
  );
}
